require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[5],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(154);


/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _BaseInput = _interopRequireDefault(__webpack_require__(155));

exports["default"] = _BaseInput["default"];
exports.BaseInput = _BaseInput["default"];

/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _BaseInput = _interopRequireDefault(__webpack_require__(156));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var BaPropTypes = _utils.propsUtils.BaPropTypes;
var uniqueId = _utils.lodash.uniqueId;
var sanitize = _utils.propsUtils.sanitize;
var isKey = _utils.keyboardUtils.isKey,
    keyNames = _utils.keyboardUtils.keyNames;
var resolveBaseTextDir = _utils.bidiUtils.resolveBaseTextDir;
var MESSAGE_TYPE_ERROR = 'error';
var MESSAGE_TYPE_WARNING = 'warning';
var MESSAGE_TYPE_INFORMATIONAL = 'informational';
var MESSAGE_TYPE_SUCCESS = 'success';

var _CLASS = _BaseInput["default"].baseInputClassName.replace(/"/g, '');

var BaseInput = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(BaseInput, _Component);

  // eventually/hopefully onValueChange/onValueAccept will be the norm, and useOnValueCallbacks can be removed
  function BaseInput(_props) {
    var _this;

    _this = _Component.call(this, _props) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_useOnValueCallbacks", !!_this.props.onValueChange || !!_this.props.onValueAccept);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "focus", function () {
      var disabled = _this.props.disabled;
      !disabled && _this.inputNode && _this.inputNode.focus();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "select", function () {
      var disabled = _this.props.disabled;
      !disabled && _this.inputNode && _this.inputNode.select();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onChange", function (e) {
      var onChange = _this.props.onChange;
      var newValue = e.type === 'click' ? _this.inputNode.value : e.target.value;

      _this.setState({
        newValue: newValue
      });

      if (_this._useOnValueCallbacks) {
        _this._onValueChange(newValue);

        onChange && onChange(e);

        if (e.type === 'click') {
          _this._onValueAccept(newValue);
        }
      } else {
        // this really really needs to get done(switch to native onChange behaviour)
        onChange && onChange(newValue, false);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onValueChange", function (newValue) {
      var onValueChange = _this.props.onValueChange;
      onValueChange && onValueChange(newValue);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onKeyUp", function (e) {
      var _this$props = _this.props,
          type = _this$props.type,
          onKeyUp = _this$props.onKeyUp;
      var newValue = e.target.value;

      _this.setState({
        newValue: newValue
      });

      if (type !== 'password' && isKey(e, keyNames.ENTER) || type === 'number' && (isKey(e, keyNames.UP
      /* 38 */
      ) || isKey(e, keyNames.DOWN
      /* 40 */
      ))) {
        if (_this._useOnValueCallbacks) {
          _this._onValueAccept(newValue);
        }
      }

      onKeyUp && onKeyUp(e);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onBlur", function (e) {
      var onBlur = _this.props.onBlur;
      var newValue = e.target.value;

      if (_this._useOnValueCallbacks) {
        _this._onValueAccept(newValue);
      }

      onBlur && onBlur(e);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onValueAccept", function (newValue) {
      var onValueAccept = _this.props.onValueAccept;

      _this.setState({
        newValue: null
      }); // toolkit widgets that call BaseInput need to check if
      // newValue !== oldValue before calling their onValueAccept
      // DO NOT do the check here, each widget applies prop limit checks


      onValueAccept && onValueAccept(newValue);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_ref", function (node) {
      return _this.inputNode = node;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_autoComplete", _this.props.autoComplete || 'off');
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_id", uniqueId('ba-common-base-input'));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_inputToRender", function (props) {
      return _this.props.inputToRender(props);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_messageType", function () {
      if (_this.props.hasValidationError && _this.props.validationErrorText) {
        return MESSAGE_TYPE_ERROR;
      }

      if (_this.props.isMoreInfo && _this.props.moreInfoText) {
        return MESSAGE_TYPE_INFORMATIONAL;
      }

      if (_this.props.successText) {
        return MESSAGE_TYPE_SUCCESS;
      }

      return undefined;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_messageNode", function () {
      var messageType = _this._messageType();

      if (messageType === MESSAGE_TYPE_ERROR) {
        return _this.props.validationErrorText;
      }

      if (messageType === MESSAGE_TYPE_INFORMATIONAL) {
        return _this.props.moreInfoText;
      }

      if (messageType === MESSAGE_TYPE_SUCCESS) {
        return _this.props.successText;
      }

      return undefined;
    });
    _this.state = {
      newValue: null
    };
    return _this;
  }

  var _proto = BaseInput.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this$props2 = this.props,
        autoFocus = _this$props2.autoFocus,
        autoSelect = _this$props2.autoSelect,
        onChange = _this$props2.onChange;
    autoFocus && this.focus();
    autoSelect && this.select(); // eslint-disable-next-line react/prop-types

    if (onChange) {
      console.warn('Warning - consider using onValueChange/onValueAccept: the behaviour of onChange will change to the native event when onValueChange/onValueAccept becomes the default behaviour');
    }
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var newValue = _ref.value;
    var oldValue = this.props.value;

    if (newValue !== oldValue) {
      this.setState({
        newValue: null
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    var newValue = this.state.newValue;

    if (newValue !== null) {
      if (this._useOnValueCallbacks) {
        this._onValueAccept(newValue);
      } else {
        // this really really needs to get done(switch to native onChange behaviour)
        this.props.onChange(newValue, true);
      }
    }
  };

  _proto.render = function render() {
    // extract props that are to be manipulated or not passed down
    var _this$props3 = this.props,
        value = _this$props3.value,
        className = _this$props3.className,
        children = _this$props3.children,
        fullWidth = _this$props3.fullWidth,
        title = _this$props3.title,
        textAlign = _this$props3.textAlign,
        dir = _this$props3.dir,
        textDir = _this$props3.textDir,
        type = _this$props3.type,
        hasValidationError = _this$props3.hasValidationError,
        validationErrorText = _this$props3.validationErrorText,
        successText = _this$props3.successText,
        isMoreInfo = _this$props3.isMoreInfo,
        moreInfoText = _this$props3.moreInfoText,
        onChange = _this$props3.onChange,
        moreInfoClickHandler = _this$props3.moreInfoClickHandler,
        onValueChange = _this$props3.onValueChange,
        onValueAccept = _this$props3.onValueAccept,
        disabled = _this$props3.disabled,
        light = _this$props3.light,
        readOnly = _this$props3.readOnly,
        inputToRender = _this$props3.inputToRender,
        style = _this$props3.style,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props3, ["value", "className", "children", "fullWidth", "title", "textAlign", "dir", "textDir", "type", "hasValidationError", "validationErrorText", "successText", "isMoreInfo", "moreInfoText", "onChange", "moreInfoClickHandler", "onValueChange", "onValueAccept", "disabled", "light", "readOnly", "inputToRender", "style"]);

    var messageType = this._messageType();

    var classNames = (0, _utils.classnames)(_CLASS, {
      fullWidth: fullWidth,
      error: messageType === MESSAGE_TYPE_ERROR,
      warning: messageType === MESSAGE_TYPE_WARNING,
      informational: messageType === MESSAGE_TYPE_INFORMATIONAL,
      success: messageType === MESSAGE_TYPE_SUCCESS
    });
    var widgetProps = (0, _extends2["default"])({
      'data-tid': this._ID + "__input"
    }, sanitize(others, null), {
      value: type === 'password' ? undefined : value || '',
      onChange: this._onChange,
      onKeyUp: this._onKeyUp,
      onBlur: this._onBlur,
      autoComplete: this._autoComplete,
      type: type,
      ref: this._ref,
      dir: resolveBaseTextDir(value, textDir, false),
      disabled: disabled || readOnly,
      light: light,
      style: (0, _extends2["default"])({}, style, textAlign ? {
        textAlign: textAlign
      } : {}),
      invalid: !!messageType,
      invalidText: this._messageNode()
    });
    return /*#__PURE__*/_react["default"].createElement("span", (0, _extends2["default"])({}, dir ? {
      dir: dir
    } : {}, {
      title: title,
      className: classNames + " " + className
    }), this._inputToRender(widgetProps), children);
  };

  return BaseInput;
}(_react.Component);

exports["default"] = BaseInput;
(0, _defineProperty2["default"])(BaseInput, "propTypes", {
  id: _propTypes["default"].string,
  'data-tid': _propTypes["default"].string,
  className: _propTypes["default"].string,
  title: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(['password', 'time', 'number']),
  textAlign: _propTypes["default"].oneOf(['left', 'right', 'center']),
  textDir: _propTypes["default"].oneOf(['', 'ltr', 'rtl', 'auto']),
  dir: _propTypes["default"].oneOf(['ltr', 'rtl']),
  fullWidth: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  // Carbon light variant of the component
  light: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  children: _propTypes["default"].node,
  onKeyUp: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  autoFocus: _propTypes["default"].bool,
  autoSelect: _propTypes["default"].bool,
  allowEmpty: _propTypes["default"].bool,

  /** callback function, to render the specific type of input */
  inputToRender: _propTypes["default"].func,

  /** callback function, to deal with input as it changes */
  onValueChange: _propTypes["default"].func,

  /** callback function, to deal with input when it is final */
  onValueAccept: _propTypes["default"].func,
  // deprecated - not supported or no equivalent in Carbon

  /** deprecated: not applicable to carbon */
  active: BaPropTypes.deprecated('deprecated: not applicable to carbon'),

  /** deprecated: not applicable to carbon */
  ariaLabelledBy: BaPropTypes.deprecated('deprecated: not applicable to carbon'),

  /** deprecated: not applicable to carbon */
  hover: BaPropTypes.deprecated('deprecated: not applicable to carbon'),

  /** deprecated: not applicable to carbon */
  icon: BaPropTypes.deprecated('deprecated: not applicable to carbon'),

  /** deprecated: not applicable to carbon */
  iconLeft: BaPropTypes.deprecated('deprecated: not applicable to carbon'),

  /** deprecated: not applicable to carbon */
  iconRight: BaPropTypes.deprecated('deprecated: not applicable to carbon'),

  /** deprecated: not applicable to carbon */
  noBottomBorder: BaPropTypes.deprecated('deprecated: not applicable to carbon'),

  /** deprecated: not applicable to carbon */
  style: BaPropTypes.deprecated('deprecated: not applicable to carbon'),
  // deprecated - supported in a different way

  /** deprecated: use onValueChange/onValueAccept to replace fireOnBlur/onChange/onBlur */
  fireOnBlur: BaPropTypes.deprecated('deprecated: use onValueChange/onValueAccept to replace fireOnBlur/onChange/onBlur'),

  /** deprecated: to be replaced/remapped when Carbon message handling is updated */
  hasValidationError: BaPropTypes.deprecated('deprecated: to be replaced/remapped when Carbon message handling is updated'),

  /** deprecated: to be replaced/remapped when Carbon message handling is updated */
  isMoreInfo: BaPropTypes.deprecated('deprecated: to be replaced/remapped when Carbon message handling is updated'),

  /** deprecated: to be replaced/remapped when Carbon message handling is updated */
  moreInfoClickHandler: BaPropTypes.deprecated('deprecated: to be replaced/remapped when Carbon message handling is updated'),

  /** deprecated: to be replaced/remapped when Carbon message handling is updated */
  moreInfoText: BaPropTypes.deprecated('deprecated: to be replaced/remapped when Carbon message handling is updated'),

  /** deprecated: to be replaced/remapped when Carbon message handling is updated */
  successText: BaPropTypes.deprecated('deprecated: to be replaced/remapped when Carbon message handling is updated'),

  /** deprecated: to be replaced/remapped when Carbon message handling is updated */
  validationErrorText: BaPropTypes.deprecated('deprecated: to be replaced/remapped when Carbon message handling is updated'),

  /** deprecated: use disabled */
  readOnly: BaPropTypes.deprecated('deprecated: use disabled')
});
(0, _defineProperty2["default"])(BaseInput, "defaultProps", {
  className: ''
});

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(157);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-baseInput{position:relative;display:inline-block}.ba-common-baseInput.is-fullWidth{display:block;width:100%}.ba-common-baseInput.is-fullWidth .bx--number--helpertext{width:100%}.ba-common-baseInput.is-error .bx--text-input__field-wrapper[data-invalid]{outline-color:red}.ba-common-baseInput.is-error .bx--text-input__invalid-icon{fill:red}.ba-common-baseInput.is-error .bx--form-requirement{color:red}.ba-common-baseInput.is-warning .bx--text-input__field-wrapper[data-invalid]{outline-color:peru}.ba-common-baseInput.is-warning .bx--text-input__invalid-icon{fill:peru}.ba-common-baseInput.is-warning .bx--form-requirement{color:peru}.ba-common-baseInput.is-informational .bx--text-input__field-wrapper[data-invalid]{outline-color:lightblue}.ba-common-baseInput.is-informational .bx--text-input__invalid-icon{fill:lightblue}.ba-common-baseInput.is-informational .bx--form-requirement{color:lightblue}.ba-common-baseInput.is-success .bx--text-input__field-wrapper[data-invalid]{outline-color:green}.ba-common-baseInput.is-success .bx--text-input__invalid-icon{fill:green}.ba-common-baseInput.is-success .bx--form-requirement{color:green}\n", ""]);

// exports
exports.locals = {
	"baseInputClassName": "\"ba-common-baseInput\""
};

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[153,0]]]);
});